import React from "react";
import { BookOpen, Video, FileText, Book, ArrowRight } from "lucide-react";
import { ScrollAnimation } from "../ScrollAnimation";

const contentCards = [
  { icon: BookOpen, title: "Artigos", description: "Sobre saúde mental, ansiedade, depressão, trauma e autocuidado." },
  { icon: Video, title: "Vídeos explicativos", description: "Orientações práticas para o dia a dia." },
  { icon: FileText, title: "Guias e materiais didáticos", description: "Para apoiar o tratamento." },
  { icon: Book, title: "Recomendações de leitura", description: "Recursos confiáveis para ampliar seu repertório." },
];

export default function Content() {
  return (
    <section id="conteudos" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-[#faf9f7]">
      <div className="max-w-5xl mx-auto">
        <ScrollAnimation animation="fade-up">
          <span className="font-sans text-sm font-semibold text-[#C2A44A] tracking-wider uppercase mb-3 block">Conteúdos</span>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={100}>
          <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#204613] mb-8 text-balance leading-tight">
            Conteúdos para apoiar sua jornada de autoconhecimento e equilíbrio
          </h2>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={200}>
          <p className="font-serif text-base sm:text-lg leading-relaxed text-[#4a4a4a] mb-4 max-w-3xl">
            Acreditamos que informação de qualidade transforma vidas. Por isso, reunimos materiais exclusivos de psicoeducação para ajudar você a compreender melhor sua mente, emoções e caminhos para o bem-estar.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={300}>
          <p className="font-sans text-lg sm:text-xl font-semibold text-[#698658] mb-10 mt-10">Aqui você encontra:</p>
        </ScrollAnimation>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12">
          {contentCards.map((card, idx) => {
            const Icon = card.icon;
            return (
              <ScrollAnimation key={idx} animation="fade-up" delay={350 + idx * 100}>
                <div className="bg-white border border-[#ACC996]/25 rounded-2xl p-5 sm:p-8 h-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-center">
                  <div className="w-14 h-14 rounded-2xl bg-[#698658]/15 flex items-center justify-center mx-auto mb-5">
                    <Icon className="w-7 h-7 text-[#698658]" />
                  </div>
                  <h4 className="font-sans text-base sm:text-lg font-semibold text-[#204613] mb-2">{card.title}</h4>
                  <p className="font-serif text-sm sm:text-base text-[#4a4a4a] leading-relaxed">{card.description}</p>
                </div>
              </ScrollAnimation>
            );
          })}
        </div>

        <ScrollAnimation animation="fade-up" delay={600}>
          <div className="bg-[#ACC996]/15 border border-[#ACC996]/25 rounded-2xl p-6 sm:p-8 mb-10">
            <p className="font-serif text-base sm:text-lg text-[#4a4a4a] leading-relaxed text-center">
              Esses conteúdos são pensados para pacientes, familiares e todos que buscam mais consciência e autonomia no cuidado emocional.
            </p>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animation="scale" delay={700}>
          <div className="text-center">
            <a
              href="#contato"
              className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-[#204613] text-white rounded-xl font-sans font-semibold text-sm sm:text-base hover:bg-[#2d5a1a] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Acessar Conteúdos
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
